<template>
  <el-input
    :class="[contentPosition ? 'position-' + contentPosition : '']"
    v-bind="$attrs"
    v-model.trim="formVal"
    clearable
    :placeholder="placeholder"
    v-on="$listeners"
    @focus="focus"
    @blur="formatValBlur"
    @input="input"
    @change="formatVal"
    @clear="clear"
  >
    <template slot="prefix">
      <slot name="prefix"></slot>
    </template>
    <template slot="suffix">
      <slot name="suffix"></slot>
    </template>
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <template slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
</template>
<!-- eslint-disable -->
<script lang="jsx">
export default {
  name: 'numberCpt',
  props: {
    placeholder: {
      type: String,
      default: () => '请输入'
    },
    value: {
      type: [String, Number],
      default: () => {}
    },
    isMoney: {
      type: Boolean,
      default: () => true
    },
    //设置保留几位
    decimalNumber: {
      type: Number,
      default: () => 2
    },
    min: {
      type: Number,
      default: () => null
    },
    max: {
      type: Number,
      default: () => null
    },
    contentPosition: {
      type: String,
      default: () => 'right'
    }
  },
  data() {
    return {
      formVal: ''
    };
  },
  watch: {
    value: {
      handler: function (val) {
        if (!this.isZero(val)) {
          return;
        }
        if (parseFloat(val) === 0) {
          this.resetToZero(parseFloat(val));
          return;
        }
        //console.log(val);
        //console.log(this.formVal);
        //外部强制改变v-model值时判断 优先外部传入值 将formVal重置为val的值
        if (val && this.formVal && parseFloat(val) != parseFloat(this.formVal)) {
          if (this.isMoney) {
            this.formVal = val.toString().replace(/\d+/, function (s) {
              return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            });
          } else {
            this.formVal = val.toString();
          }
        } else if (val && !this.formVal) {
          //初始化时formVal为空 v-model有值时将val格式化后赋值给formVal
          if (this.isMoney) {
            this.formVal = val.toString().replace(/\d+/, function (s) {
              return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            });
          } else {
            this.formVal = val.toString();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    isZero(val) {
      if (val === '' || val === undefined || val === null) {
        this.formVal = '';
        this.$emit('input', '');
        return false;
      } else {
        return true;
      }
    },
    resetToZero(val) {
      if (!val) {
        const defaultVal = 0;
        this.formVal = defaultVal.toFixed(this.decimalNumber);
      }
    },
    clear() {
      this.formVal = '';
      this.$emit('input', '');
    },
    input(val) {
      //清除所有字母
      val = val.replace(/[a-zA-Z]/g, '');

      if (!this.isZero(this.formVal)) {
        return;
      }
      if (val.length > 18) {
        val = val.slice(0, 18);
      }

      val = val.replace(/[^\d.-]/g, ''); //清除"数字"和"."以外的字符
      val = val.replace(/^\./g, '');
      let first = '';
      if (val[0] === '-') {
        first = '-';
      }
      if (val.indexOf('-') > -1 && val.lastIndexOf('-') != 0) {
        val = val.replaceAll('-', '');
      }
      val = first + val;
      val = val.replace(/^\./g, ''); //验证第一个字符是数字
      val = val.replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
      val = val.replace(/\-{2,}/g, '-'); //只保留第一个, 清除多余的
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      if (this.max != null && parseFloat(val) > this.max) {
        console.log(parseFloat(val));

        val = this.max.toString();
      }
      if (this.decimalNumber - 0 > 0) {
        const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{1,${this.decimalNumber + ''}}).*$`);
        val = val.replace(reg, '$1$2.$3');
      }
      this.$nextTick(() => {
        this.formVal = val;
        this.$emit('input', val);
      });
    },
    focus() {
      try {
        if (!this.isZero(this.formVal)) {
          return;
        }
        if (!parseFloat(this.formVal)) {
          this.formVal = '0';
        }
        this.formVal = this.formVal.replace(/,/g, '');
        if (this.formVal) {
          this.formVal = parseFloat(this.formVal).toFixed(this.decimalNumber);
        } else {
          this.formVal = '0';
        }
      } catch (error) {
        //console.error(error);
      }
    },
    formatValBlur() {
      if (!this.isZero(this.formVal)) {
        return;
      }
      //清除所有字母
      this.formVal = this.formVal.replace(/[a-zA-Z]/g, '');
      if (this.min != null && this.min > parseFloat(this.formVal)) {
        this.formVal = this.min.toString();
        this.$emit('input', this.min);
      }
      if (this.formVal) {
        let val = this.round(this.formVal, this.decimalNumber);
        if (this.isMoney) {
          val = val.replace(/\d+/, function (s) {
            return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          });
        }
        this.formVal = '0';
        this.$nextTick(() => {
          if (parseFloat(this.formVal) === 0 && 0 === parseFloat(val)) {
            this.$emit('input', 0);
          } else {
            this.formVal = val;
          }
        });
      } else {
        this.resetToZero(this.formVal);
      }
    },
    formatVal(event) {
      try {
        if (!this.isZero(event)) {
          this.$emit('input', 0);
          return;
        }
        event = event.replace(/,/g, '');

        //清除所有字母
        event = event.replace(/[a-zA-Z]/g, '');

        if (event) {
          event = this.round(event, this.decimalNumber);
        } else {
          event = 0;
        }
        this.$nextTick(() => {
          this.$emit('input', event);
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.noSuffix {
  ::v-deep .el-input__inner {
    padding-right: 3px;
  }
}
.position-right {
  ::v-deep .el-input__inner {
    text-align: right !important;
  }
}
.position-left {
  ::v-deep .el-input__inner {
    text-align: left !important;
  }
}
::v-deep .el-input-group__prepend {
  padding: 0px;
  border: 0px;
}
::v-deep .el-input-group__append {
  padding: 0px !important;
  border: 0px;
}
::v-deep .el-input__inner {
  border-radius: 4px !important;
  padding-left: 10px !important;
  padding-right: 30px !important;
}
</style>
